import { createSlice } from '@reduxjs/toolkit';

import getUserInfo, {
  getUserBalanceLogs,
  getUserRequestLogs,
} from './UserInfoActions';

import { USER } from 'features/userPage/core/ReduxNames';

const initialState = {
  info: null,
  isInfoFetching: false,
  balanceLogsHistory: null,
  isBalanceLogsHistoryFetching: false,
  requestLogs: null,
  isRequestLogsFetching: false,
};

const userInfoSlice = createSlice({
  name: USER,
  initialState,
  reducers: {
    setInfoFetch: (state, action) => {
      state.isInfoFetching = action.payload;
      state.isBalanceLogsHistoryFetching = action.payload;
      state.isRequestLogsFetching = action.payload;
    },
  },
  extraReducers: {
    [getUserInfo.pending.type]: (state) => {
      Object.assign(state, initialState);
    },
    [getUserInfo.fulfilled.type]: (state, action) => {
      state.info = action.payload.data;
    },
    [getUserBalanceLogs.pending.type]: (state) => {
      state.balanceLogsHistory = null;
    },
    [getUserBalanceLogs.fulfilled.type]: (state, action) => {
      state.balanceLogsHistory = action.payload.data;
    },
    [getUserRequestLogs.pending.type]: (state) => {
      state.requestLogs = null;
    },
    [getUserRequestLogs.fulfilled.type]: (state, action) => {
      state.requestLogs = action.payload.data;
    },
  },
});

export const { setInfoFetch } = userInfoSlice.actions;
export default userInfoSlice.reducer;
